import { useEffect } from 'react'
import { get as localDbGet } from 'idb-keyval'
import Spinner from 'components/Spinner/Spinner'
import Button from './components/Button'
import Link from './components/Link'
import { CloudWatchLogger } from 'helpers/cloudWatchLogger'
import ErrorPageStyled from './ErrorPageStyled'

const ErrorPage = ({
  onRetry = () => {},
  error = undefined
}) => {
  useEffect(() => {
    async function logError() {
      try {
        const tenantData = JSON.parse(await localDbGet('get-tenant-data'))

        const { env, tenantId } = tenantData

        const { jsHeapSizeLimit, totalJSHeapSize, usedJSHeapSize } = window.performance.memory

        const errorData = {
          tenantId,
          url:  window.location.href,
          error,
          performance: {
            jsHeapSizeLimit,
            totalJSHeapSize,
            usedJSHeapSize
          }
        }

        CloudWatchLogger(
          `/aws/lambda/rest-${env}`,
          'error',
          'Performance & Data Error',
          errorData
        )
      } catch (error) {
        console.error('Unable to log error: ', error)
      }
    }

    logError()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  function handleTryAgain() {
    onRetry()
  }

  return (
    <ErrorPageStyled role="alert">
      <div className='spinner-container'>
        <Spinner />
      </div>
      <h1>Something isn't quite right!</h1>
      <Button
        className='tryAgainButton'
        onClick={() => handleTryAgain()}
      >
        Go back and try again
      </Button>
      
      <p>
        or go back to the
        {" "}
        <Link to="/">Home page</Link>
      </p>

      {error && (
        <div className="error-message-container">
          <p>
            <strong>Out of interest, this is what went wrong:</strong><br/>
            <span className='error'>{error}</span>
          </p>
        </div>
      )}
    </ErrorPageStyled>
  )
}

export default ErrorPage
